export default "__VITE_ASSET__BMP6DEeL__"